import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from '../../../config/config'; // Importing development configuration

/**
 * Class representing the filter activation registration view.
 * @extends JetView
 */
export default class FilteractivateRegistrationView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        const left = {
            // Left section containing input fields
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Input for Cedula
                            name: 'Cedula',
                            label: _('Cedula del cliente:'), // Label for Cedula
                            labelPosition: 'top',
                            placeholder: _('Cedula del cliente:'), // Placeholder for Cedula
                        },
                        {
                            view: 'text', // Input for Email
                            name: 'Email',
                            label: _('Email del cliente:'), // Label for Email
                            labelPosition: 'top',
                            placeholder: _('Email del cliente:'), // Placeholder for Email
                            invalidMessage: _('Campo No Valido'), // Invalid message for Email
                        },
                    ],
                },
            ],
        };

        const upper_section = {
            // Upper section of the form
            css: 'father-container',
            height: screen == 'small' ? 160 : 0, // Conditional height based on screen size
            rows: [
                {
                    margin: 10,
                    cols: [left], // Including left section
                },
            ],
        };

        const datos = {
            // Data object for registration
            ValorPagar: '1.2426',
            ValorApostado: '1.00',
            PremioProyectado: '1.24',
            Estado: 'Ganador',
            Ganador: 'Si',
        };

        const buttons = {
            // Button section for actions
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity for layout
                        {
                            view: 'button', // Clear button
                            value: _('Limpiar'), // Button label
                            width: screen == 'small' ? 0 : 100, // Conditional width
                            minWidth: 200,
                            click: () => {
                                // Click event for clearing the form
                                this.getRoot().clear();
                                $$('formActivateRegistration').hide();
                            },
                        },
                        {
                            view: 'button', // Consult button
                            value: _('Consultar'), // Button label
                            type: 'form',
                            width: screen == 'small' ? 0 : 100, // Conditional width
                            minWidth: 200,
                            hotkey: 'enter', // Hotkey for the button
                            click: () => {
                                // Click event for consulting data
                                $$('formActivateRegistration').hide();
                                const filterdata = this.getRoot().getValues(); // Get form values
                                const vthis = this; // Reference to the current context
                                if (
                                    (filterdata.Cedula !== '' && filterdata.Cedula !== 'undefined') ||
                                    (filterdata.Email !== '' && filterdata.Email !== 'undefined')
                                ) {
                                    webix
                                        .ajax() // AJAX request to fetch data
                                        .get(
                                            devConfig.geturlApi() + '/UserManagement/GetActivateRegistration',
                                            'Cedula=' + filterdata.Cedula + '&Email=' + filterdata.Email,
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    // Error handling for AJAX request
                                                    webix.message(_('Error! '));
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    // Success handling for AJAX request
                                                    var resp = JSON.parse(text); // Parse response
                                                    if (!resp.HasError) {
                                                        // Check for errors in response
                                                        vthis.app.callEvent(
                                                            'activateRegistration:data',
                                                            [resp.data], // Trigger event with response data
                                                        );
                                                        $$('FilterActivateRegistration').hide(); // Hide filter view
                                                        $$('formActivateRegistration').show(); // Show registration form
                                                        $$('back-button').show(); // Show back button
                                                    } else {
                                                        webix.message({
                                                            title: '¡Error!',
                                                            type: 'alert-error',
                                                            text: _(
                                                                'El usuario no se encuentra o ya fue activado', // Error message for user not found or already activated
                                                            ),
                                                        });
                                                    }
                                                },
                                            },
                                        );
                                } else {
                                    webix.message({
                                        text: _('Filtre Minimo por un campo'), // Message for minimum filter requirement
                                        type: 'error',
                                        expire: 1000,
                                    });
                                }
                            },
                        },
                    ],
                },
            ],
        };

        return {
            // Return the main configuration for the form
            view: 'form',
            id: 'FilterActivateRegistration',
            rows: [upper_section, buttons], // Include upper section and buttons
            rules: {
                Email: webix.rules.isEmail, // Validation rule for Email
            },
        };
    }

    /**
     * Initializes the view after it is rendered.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            // Execute when Webix is ready
            if (screen.width < 500) {
                // Check screen width
                $$('grav').hide(); // Hide element if screen is small
            }
        });
    }
}

// FILE DOCUMENTED
